'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/oliward/Sites/ihg-gfg-2021/site/web/app/themes/sage/node_modules/core-js/internals/is-pure.js
// module id = 15
// module chunks = 0